module.exports = __webpack_public_path__ + "img/1DX_0362.a7dfae79.jpg";